export default "__VITE_ASSET__MqTZErwn__"